import { Navigate, Route, Routes } from 'react-router-dom'
import AdminUsers from '../pages/adminUsers'
import OptionGroup from '../pages/optionGroup'
import CompanysRoutes from '../pages/company/routes'
// import Area from '../pages/area'
// import Department from '../pages/departments'

const Setting = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="admin-users" />} />
      <Route path="admin-users" element={<AdminUsers />} />
      <Route path="companies/*" element={<CompanysRoutes />} />
      <Route path="option-group" element={<OptionGroup />} />
    </Routes>
  )
}

export default Setting
